import React from 'react';
import Modal from '@components/Modals';
import { capitalize } from '@support/string';

export default function LoginErrorModal({ onClose, message, open, provider = undefined }) {
  let title = 'Error signing in';
  if (provider) {
    title = `Error signing in with ${capitalize(provider)}`;
  }

  if (message?.startsWith('Please sign into')) {
    title = `${capitalize(provider)} Account Not Found`;
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose}>
      <div className="modal-header">{title}</div>
      <div className="modal-content-padded">{message}</div>
      <div className="modal-content-padded">
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Continue
        </button>
      </div>
    </Modal>
  );
}
